var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSabehubAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 243,
    viewBox: "0 0 184 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4606_3464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.067 2.56494V150.291C181.067 199.582 141.108 239.541 91.8157 239.541C42.5239 239.541 2.56482 199.582 2.56482 150.291V2.56494H181.067Z",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.37 14.0405V151.829C168.37 193.934 134.239 228.066 92.1345 228.066C50.0304 228.066 15.8982 193.934 15.8982 151.829V14.0405H168.37Z",
    stroke: "white",
    strokeWidth: 4.63257
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3448 168.17H166.631",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8533 78.1865H166.631",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0734 199.312L75.6945 170.441L92.0351 181.506L102.734 170.441L148.018 200.558",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2072 198.434C70.8581 207.08 93.9402 217.779 125.376 198.58",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1816 89.1045V152.269H130.798",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1816 15.0952V78.2596",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0495 107.57C65.1759 110.843 67.3287 117.799 60.9503 126.842C55.1612 135.049 66.1526 139.445 66.1526 146.773C66.1528 152.195 59.4845 153.661 58.6055 160.329C57.9208 165.523 60.3641 167.242 60.9503 167.73",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3371 122.812C47.3941 127.282 46.9543 129.334 42.5576 136.588C37.352 145.177 46.6609 144.795 46.661 152.123C46.661 157.545 36.3024 160.476 43.3371 169.05",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.334 107.277C110.607 104.15 117.563 101.997 126.606 108.376C134.813 114.165 139.209 103.173 146.537 103.173C151.959 103.173 153.425 109.842 160.093 110.721C165.287 111.405 167.006 108.962 167.494 108.376",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.869 125.989C127.339 121.932 129.39 122.372 136.645 126.768C145.234 131.974 144.852 122.665 152.179 122.665C157.602 122.665 160.533 133.024 169.106 125.989",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.622 31.8022C134.033 31.8022 140.196 37.1432 141.474 44.186H149.704V49.3153H141.524C140.366 56.5026 134.135 61.9922 126.622 61.9922C118.285 61.9922 111.527 55.2339 111.527 46.8972C111.527 38.5605 118.285 31.8022 126.622 31.8022ZM126.622 36.9316C121.118 36.9316 116.656 41.3934 116.656 46.8972C116.656 52.401 121.118 56.8628 126.622 56.8628C132.125 56.8628 136.587 52.401 136.587 46.8972C136.587 41.3934 132.125 36.9316 126.622 36.9316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9229 77.9665C79.0651 66.169 66.3883 56.7163 53.3451 56.7163C40.3018 56.7163 28.431 64.3371 24.2543 77.9665",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8533 39.6655C25.8321 31.5385 39.2422 26.3794 54.2243 26.3794C69.2065 26.3794 82.6165 31.5385 91.5954 39.6655",
    stroke: "white",
    strokeWidth: 5.12936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.207 14.3628L33.1942 31.2897M52.9056 14.3628V27.4793M81.9964 14.3628L73.7894 31.2897",
    stroke: "white",
    strokeWidth: 5.12936
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4606_3464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183.631,
    height: 242.106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSabehubAppIcon);
export default __webpack_public_path__ + "static/media/header-sabehub-app-icon.4d23454281d603875dde81a5f3a6577e.svg";
export { ForwardRef as ReactComponent };